import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getApiUrl, setApiUrl } from '../config/api';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [backendUrl, setBackendUrlState] = useState('');
  const [showServerSetting, setShowServerSetting] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setBackendUrlState(getApiUrl());
  }, []);

  const handleBackendUrlChange = (e) => {
    const val = e.target.value;
    setBackendUrlState(val);
    setApiUrl(val);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const activeApiUrl = setApiUrl(backendUrl) || getApiUrl();

    try {
      const response = await fetch(`${activeApiUrl}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();
      if (response.ok) {
        const displayName = data.nama || data.nama_user || data.fullname || data.nama_lengkap || data.user || username;
        localStorage.setItem('token', data.token || 'dummy-token');
        localStorage.setItem('user', displayName);
        localStorage.setItem('nama_user', displayName);
        localStorage.setItem('mainmenu', JSON.stringify(data.mainmenu));
        localStorage.setItem('submenu', JSON.stringify(data.menu));

        // Simpan sekali secara global ke localStorage agar semua page menggunakannya
        localStorage.setItem('apiUrl', activeApiUrl);
        
        navigate('/home');
      } else {
        setError(data.message || 'Username atau Password salah.');
      }
    } catch (err) {
      setError(`Gagal terhubung ke server backend (${activeApiUrl}). Pastikan Alamat IP server sudah benar.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.body}>
      {/* Background Subtle Glowing Accents */}
      <div style={styles.glowBlob1}></div>
      <div style={styles.glowBlob2}></div>

      <div style={styles.loginContainer}>
        {/* Brand Header Section */}
        <div style={styles.brandSection}>
          <img src="/logo.png" alt="SIMRS2 Logo" style={styles.brandLogo} />
          <p style={styles.brandSubtitle}>
            Sistem Informasi Management Rumah Sakit (Finance)
          </p>
        </div>

        {/* Login Glassmorphism Card */}
        <div style={styles.loginCard}>
          <div style={styles.cardHeader}>
            <h2 style={styles.cardTitle}>Masuk ke Akun Anda</h2>
            <p style={styles.cardSub}>Masukkan username dan password untuk mengakses sistem</p>
          </div>

          <form onSubmit={handleSubmit}>
            {error && (
              <div style={styles.errorAlert}>
                <i className="bi bi-exclamation-triangle-fill me-2"></i>
                <span>{error}</span>
              </div>
            )}

            {/* Input Username */}
            <div style={styles.inputGroup}>
              <label style={styles.inputLabel}>Username / Email</label>
              <div style={styles.inputWrapper}>
                <i className="bi bi-person-fill" style={styles.inputIcon}></i>
                <input
                  type="text"
                  placeholder="Masukkan username atau email"
                  required
                  autoComplete="off"
                  autoFocus
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  style={styles.input}
                />
              </div>
            </div>

            {/* Input Password */}
            <div style={styles.inputGroup}>
              <label style={styles.inputLabel}>Password</label>
              <div style={styles.inputWrapper}>
                <i className="bi bi-lock-fill" style={styles.inputIcon}></i>
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Masukkan password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={styles.input}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={styles.togglePasswordBtn}
                  title={showPassword ? "Sembunyikan Password" : "Tampilkan Password"}
                >
                  <i className={`bi ${showPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'}`}></i>
                </button>
              </div>
            </div>

            {/* Pengaturan IP Server Backend (Cukup Sekali Setting) */}
            <div style={{ marginBottom: '1.25rem' }}>
              <div
                onClick={() => setShowServerSetting(!showServerSetting)}
                style={{
                  cursor: 'pointer',
                  fontSize: '0.75rem',
                  color: '#2dd4bf',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '0.4rem',
                  userSelect: 'none',
                  padding: '4px 2px'
                }}
              >
                <span>
                  <i className="bi bi-hdd-network-fill me-1.5 text-warning"></i>
                  IP Backend: <span style={{ color: '#ffffff', fontWeight: 'bold' }}>{backendUrl || 'Belum diatur'}</span>
                </span>
                <i className={`bi bi-chevron-${showServerSetting ? 'up' : 'down'}`}></i>
              </div>

              {showServerSetting && (
                <div style={styles.inputWrapper}>
                  <i className="bi bi-gear-fill" style={styles.inputIcon}></i>
                  <input
                    type="text"
                    placeholder="Contoh: http://202.155.94.169:7000"
                    value={backendUrl}
                    onChange={handleBackendUrlChange}
                    style={{ ...styles.input, fontSize: '0.78rem' }}
                  />
                </div>
              )}
            </div>

            {/* Submit Button */}
            <button type="submit" disabled={loading} style={styles.btnSignIn}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  <span>MEMPROSES...</span>
                </>
              ) : (
                <>
                  <span>MASUK SEKARANG</span>
                  <i className="bi bi-arrow-right-short fs-5 ms-1"></i>
                </>
              )}
            </button>
          </form>
        </div>

        {/* Footer Section */}
        <div style={styles.footerText}>
          <div style={styles.sslBadge}>
            <i className="bi bi-shield-lock-fill me-1" style={{ color: '#2dd4bf' }}></i>
            Enkripsi Keamanan 256-Bit SSL
          </div>
          <div>powered by <strong>SIMRS2 - Sistem Informasi Management Rumah Sakit (Finance)</strong></div>
        </div>
      </div>
    </div>
  );
};

// CSS-in-JS Styles dengan Glassmorphism & Emerald Theme
const styles = {
  body: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(rgba(15, 30, 50, 0.55), rgba(15, 30, 50, 0.65)), url("/login_bg.jpg") no-repeat center center / cover',
    position: 'relative',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    overflow: 'hidden',
    padding: '1.5rem',
  },
  glowBlob1: {
    display: 'none',
    pointerEvents: 'none',
  },
  glowBlob2: {
    display: 'none',
    pointerEvents: 'none',
  },
  loginContainer: {
    width: '100%',
    maxWidth: '460px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 10,
  },
  brandSection: {
    textAlign: 'center',
    marginBottom: '1.5rem',
  },
  brandLogo: {
    maxWidth: '130px',
    height: 'auto',
    filter: 'drop-shadow(0 4px 18px rgba(13, 148, 136, 0.4))',
    marginBottom: '0.4rem',
  },
  brandSubtitle: {
    fontSize: '0.8rem',
    color: '#cbd5e1',
    marginTop: '0.2rem',
    margin: 0,
    fontWeight: '500',
  },
  loginCard: {
    width: '100%',
    background: 'rgba(15, 23, 42, 0.70)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.12)',
    borderRadius: '16px',
    padding: '2.2rem 2rem',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.4)',
  },
  cardHeader: {
    marginBottom: '1.5rem',
    textAlign: 'center',
  },
  cardTitle: {
    fontSize: '1.2rem',
    fontWeight: '700',
    color: '#ffffff',
    margin: 0,
  },
  cardSub: {
    fontSize: '0.78rem',
    color: '#94a3b8',
    marginTop: '0.25rem',
    margin: 0,
  },
  errorAlert: {
    background: 'rgba(239, 68, 68, 0.15)',
    border: '1px solid rgba(239, 68, 68, 0.4)',
    color: '#fca5a5',
    padding: '10px 14px',
    borderRadius: '8px',
    fontSize: '0.8rem',
    marginBottom: '1.25rem',
    display: 'flex',
    alignItems: 'center',
  },
  inputGroup: {
    marginBottom: '1.25rem',
  },
  inputLabel: {
    display: 'block',
    fontSize: '0.75rem',
    fontWeight: '600',
    color: '#cbd5e1',
    marginBottom: '0.35rem',
    letterSpacing: '0.2px',
  },
  inputWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  inputIcon: {
    position: 'absolute',
    left: '14px',
    color: '#64748b',
    fontSize: '1rem',
    pointerEvents: 'none',
  },
  input: {
    width: '100%',
    padding: '11px 42px 11px 40px',
    background: 'rgba(30, 41, 59, 0.6)',
    border: '1px solid rgba(255, 255, 255, 0.15)',
    borderRadius: '10px',
    fontSize: '0.88rem',
    color: '#ffffff',
    outline: 'none',
    transition: 'all 0.2s ease',
  },
  togglePasswordBtn: {
    position: 'absolute',
    right: '12px',
    background: 'none',
    border: 'none',
    color: '#94a3b8',
    cursor: 'pointer',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    fontSize: '1rem',
  },
  btnSignIn: {
    width: '100%',
    padding: '12px',
    background: 'linear-gradient(135deg, #0d9488 0%, #059669 100%)',
    border: 'none',
    borderRadius: '10px',
    color: '#ffffff',
    fontSize: '0.9rem',
    fontWeight: '700',
    letterSpacing: '0.5px',
    cursor: 'pointer',
    marginTop: '0.5rem',
    boxShadow: '0 4px 18px rgba(13, 148, 136, 0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
  },
  footerText: {
    marginTop: '1.75rem',
    color: '#94a3b8',
    fontSize: '0.75rem',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.4rem',
  },
  sslBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    background: 'rgba(255, 255, 255, 0.07)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '20px',
    padding: '3px 10px',
    fontSize: '0.7rem',
    color: '#94a3b8',
  }
};

export default Login;